"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const countries_1 = require("../countries");
class UnderWriterZone {
    constructor(zones) {
        this.zones = zones;
        this.countries = countries_1.getAllCoveredCountries();
    }
    getZoneByCountry(countryCode, state) {
        var _a;
        let zone = null;
        const countryObj = this.countries.find((c) => c.id === countryCode ||
            c.alpha2 === countryCode ||
            c.alpha3 === countryCode);
        if (countryObj) {
            const zonesByGroup = this.zones.filter((z) => z.group === countryObj.group);
            if (zonesByGroup.length) {
                const zonesByCountry = zonesByGroup.filter((z) => {
                    var _a;
                    return (z.coversAllGroup ||
                        ((_a = z.countries) === null || _a === void 0 ? void 0 : _a.find((c) => c.id === countryObj.id ||
                            c.id === countryObj.alpha2 ||
                            c.id === countryObj.alpha3)));
                });
                if (state) {
                    const zoneByState = zonesByCountry.find((z) => {
                        var _a;
                        return (z.coversAllGroup ||
                            ((_a = z.countries) === null || _a === void 0 ? void 0 : _a.find((c) => { var _a; return c.coversALLCountry || ((_a = c.states) === null || _a === void 0 ? void 0 : _a.includes(state)); })));
                    });
                    zone = (_a = zoneByState === null || zoneByState === void 0 ? void 0 : zoneByState.zone) !== null && _a !== void 0 ? _a : null;
                }
                if (zonesByCountry.length === 1)
                    zone = zonesByCountry[0].zone;
            }
        }
        return zone;
    }
}
exports.default = UnderWriterZone;
//# sourceMappingURL=underwriterZone.class.js.map